<template>
    <div>
        <h2 v-html="task.question" />
        <div>
            <p v-html="task.taskable.prepared_drag_content" />
        </div>
        <div class="bg-light p-4">
            <b>Az alábbi szavakat illesztheti be a szövegbe:</b>
            <div class="mt-4 choosable-words">
                <span
                    v-for="(word, index) in choosableWords"
                    :key="`invalid-word-${index}`"
                    :draggable="true"
                    @dragstart="drag"
                    class="badge badge-primary mx-2 p-2"
                    style="cursor: pointer;"
                    v-html="word.value"
                    :id="`word-${word.index}`"
                    :data-original-index="word.index"
                ></span>
            </div>
        </div>
    </div>
</template>
<script>
import {filter, each, find} from "lodash";

export default {
    props: {
        task: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit('input', this.form);
            },
        },
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                selected_words: [],
            },
            choosableWords: [],
        }
    },
    computed: {
        preparedDragContent() {
            return this.task.taskable.prepared_drag_content;
        },
    },
    mounted() {
        this.rescanElement(true);
        this.makeChoosableWords();
        this.$emit('input', this.form);
    },
    methods: {
        rescanElement(wordForcePushNull = false) {
            each(document.getElementsByClassName('changable'), (element, index) => {
                if (wordForcePushNull) {
                    this.form.selected_words.push(null);
                }

                element.addEventListener('dragover', (event) => {
                    event.preventDefault();
                });

                element.addEventListener('drop', this.drop);
            });
        },
        drag(event) {
            event.dataTransfer.setData("Text", event.target.id);
        },
        makeChoosableWords() {
            this.choosableWords = filter(this.task.taskable.gaming_words, (word) => {
                return !find(this.form.selected_words, {index: parseInt(word.index)});
            });
        },
        drop(event) {
            event.preventDefault();

            let data = event.dataTransfer.getData("Text");
            let word = document.getElementById(data).cloneNode(true);
            word.setAttribute('data-index', event.target.dataset.index);
            word.classList.add('changeable');
            word.addEventListener('dragover', (evt) => {
                evt.preventDefault();
            })
            word.addEventListener('drop', this.drop);

            event.target.parentNode.replaceChild(word, event.target);

            document.getElementById(data).addEventListener('click', (event) => {
                let newElement = document.createElement('span');
                newElement.setAttribute('class', 'changable');
                newElement.setAttribute('data-index', event.target.dataset.index);
                newElement.innerHTML = '.....................';

                event.target.parentNode.replaceChild(
                    newElement,
                    event.target,
                );

                this.form.selected_words[event.target.dataset.index] = null;

                this.$forceUpdate();

                this.$nextTick(() => {
                    this.rescanElement();
                    this.makeChoosableWords();
                    this.$forceUpdate();
                })
            });

            let originalWord = find(this.task.taskable.gaming_words, {index: parseInt(document.getElementById(data).dataset.originalIndex)});

            this.form.selected_words[event.target.dataset.index] = originalWord;

            this.makeChoosableWords();

            this.$forceUpdate();
        }
    }
}
</script>
